<template>
  <div class="page-progress">
    <div class="progress">
      <div class="strategies">
        <transition-group name="badges_card" class="badges-cards" tag="div" v-if="badges">
          <md-card
            class="badges md-elevation-2 md-layout-item"
            :key="index"
            v-for="(item, index) in badges_filtered"
          >
            <md-card-header>
              <md-card-expand>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <div class="md-layout">
                      <div class="md-layout-item">
                        <div class="md-layout-item md-margin-bt-15">
                          <div class="md-title">{{ item.title }}</div>
                        </div>
                        <div class="md-layout md-margin-bt-15">
                          <div class="md-layout md-alignment-center-center">
                            <svg class="line-progress" height="17" width="100%">
                              <g class="progress-container">
                                <line x1="0" y1="0" x2="100%" y2="100%" stroke-width="30" />
                              </g>
                              <g class="progress-content">
                                <line
                                  x1="0"
                                  y1="0"
                                  :x2="item.progress"
                                  y2="0"
                                  stroke="#457B9D"
                                  fill="transparent"
                                  :stroke-dashoffset="item.progress"
                                  stroke-width="34"
                                />
                              </g>
                            </svg>
                          </div>
                          <div class="md-layout-item md-size-30 md-small-size-50">
                            <span
                              class="progress-text"
                            >{{ item.completed_activities }}/{{ item.total_activities }} completed</span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="badge-icon md-layout md-size-20 md-alignment-center-center"
                        :class="{ completed: item.completed }"
                      >
                        <img :src="item.icon" />
                      </div>
                    </div>
                    <md-card-expand-trigger>
                      <md-button class="view-more">View details</md-button>
                    </md-card-expand-trigger>
                  </div>
                </div>
                <div class="md-layout">
                  <md-card-expand-content>
                    <md-card-content>
                      <div
                        class="badge-activities md-layout-item"
                        :key="index"
                        v-for="(item, index) in item.activities"
                      >
                        <div class="md-layout">
                          <div class="placeholder md-layout-item md-size-5">
                            <div class="badge-placeholder" :class="{ completed: item.completed }"></div>
                          </div>
                          <div class="md-layout-item">
                            <div @click="goTo(item.id)" class="md-title submission">{{ item.title }}</div>
                            <div class="completed-date" v-if="item.date != ''">
                              Date completed:
                              {{ item.date }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <md-card-expand-trigger>
                        <md-button class="view-less">View less</md-button>
                      </md-card-expand-trigger>
                    </md-card-content>
                  </md-card-expand-content>
                </div>
              </md-card-expand>
            </md-card-header>
          </md-card>
        </transition-group>
        <div v-if="badges && badges.length > min_count_badges" class="fb-text-center">
          <md-button class="latest-activity-show all-less-btn" @click="filtered = !filtered">
            <span v-if="filtered">Show all</span>
            <span v-else>Show less</span>
          </md-button>
        </div>

        <div class="md-title" v-if="activities && activities.length > 0">Completed</div>
        <div class="strategies-cards" v-if="activities && activities.length > 0">
          <md-card
            class="strategy completed md-elevation-2 md-layout-item"
            :key="index"
            v-for="(item, index) in activities"
          >
            <div @click="goTo(item.id)">
              <md-card-header>
                <md-card-media>
                  <img alt v-if="item.icon" :src="item.icon" />
                </md-card-media>
                <md-card-header-text>
                  <div class="md-title">{{ item.title }}</div>
                  <div
                    class="description"
                    v-if="item.competencies && item.competencies.length > 0"
                  >Competency: {{ item.competencies ? item.competencies.join(", ") : ""}}</div>
                  <div class="completed-date">Date completed: {{ item.completed }}</div>
                  <div class="badge"></div>
                </md-card-header-text>
              </md-card-header>
            </div>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Progress",
  components: {},
  computed: {
    badges_filtered() {
      if (this.filtered && this.badges) {
        return this.badges.slice(0, this.min_count_badges);
      }
      return this.badges;
    },
  },
  mounted() {
    document.querySelector(".region.region-content").remove();
    this.activities = window.drupalSettings.controller
      ? window.drupalSettings.controller.activities
      : [];
    this.badges = window.drupalSettings.controller
      ? window.drupalSettings.controller.badges
      : [];
    this.all_activity = window.drupalSettings.controller
      ? window.drupalSettings.controller.all_activity
      : [];
    this.user_info = window.drupalSettings.controller
      ? window.drupalSettings.controller.user_info
      : [];
  },

  data() {
    return {
      activities: [],
      badges: [],
      all_activity: [],
      user_info: [],
      filtered: true,
      min_count_badges: 3,
    };
  },
  methods: {
    goTo(nodeId) {
      if (
        window.drupalSettings.controller.submissions &&
        window.drupalSettings.controller.submissions[nodeId] !== undefined
      ) {
        window.location.href =
          "/activity-submission/" +
          window.drupalSettings.controller.submissions[nodeId];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.md-margin-bt-15 {
  margin-bottom: 20px;
}
</style>
